/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react'
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
   sliderDots: {
    alignSelf: '',
    marginTop: '2rem',
    '& ul': {
       display: 'flex',
       listStyleType: 'none',
       paddingLeft: '0'
     },
     '& ul li div': {
       width: '25px',
       height: '5px',
       margin: '5px',
       opacity: '0.45',
       background: '#555555',
       color: '#fff',
       textAlign: 'center',
       cursor: 'pointer',
       borderRadius: '3px',
     },
     '& .active': {
       background: `${theme.palette.common.black} !important`,
       opacity: '1'
     }
   },
 }));


const SliderDots = ({ cards, currentCardIndex, setCurrentCardIndex }) => {
  const classes = useStyles();

  return (
   <div className={classes.sliderDots}>
   <ul style={{ margin: '0' }}>
      {cards?.length &&
         cards.map((card, index) => (
         <li key={`${card.title} + ${index}`} onClick={() => setCurrentCardIndex(index)}>
            {" "}
            <div
               data-index={card}
               className={Number(currentCardIndex) === index ? "active" : ""}
            ></div>
         </li>
      ))}
   </ul>
</div>
  )
}

export default SliderDots